import React, { cloneElement } from 'react'
import { renderToStaticMarkup } from 'react-dom/server'
import { Icon as ManyUIIcon, l } from '@manychat/manyui'

import { PreviewComponent } from 'common/builder/components/chart/FlowChart/components/Block/components/PreviewComponent/PreviewComponent'
import * as styles from 'common/builder/components/chart/FlowChart/components/Block/generic/Cards/CardPreview.styles'
import { DynamicImagePreview } from 'common/builder/components/chart/FlowChart/components/Block/generic/Cards/DynamicImagePreview/DynamicImagePreview'
import { CARD_WIDTH } from 'common/builder/components/chart/FlowChart/components/Block/generic/Cards/lib/constants'
import { getRatio } from 'common/builder/components/chart/FlowChart/components/Block/generic/Cards/lib/getRatio'
import { ContentContainer } from 'common/builder/components/chart/FlowChart/components/ContentContainer/ContentContainer'
import { Colors } from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import TextWithIcon from 'common/builder/components/chart/FlowChart/nodes/shared/TextWithIcon'
import {
  CardAspectRatio,
  CardImageType,
  FlowChartCard,
} from 'common/builder/components/chart/FlowChart/types/FlowChartCardsBlock'

interface CardPreviewProps {
  card: FlowChartCard
}

const PLACEHOLDER_ICON = renderToStaticMarkup(
  cloneElement(<ManyUIIcon.Image size={72} color={Colors.DISABLED} />),
)

export const CardPreview = ({ card }: CardPreviewProps) => {
  const ratio = getRatio(card.aspectRatio)

  if (!card.image) {
    return (
      <ContentContainer
        isEmpty
        style={
          card.aspectRatio === CardAspectRatio.SQUARE ? styles.ImageEmptySquare : styles.ImageEmpty
        }
      >
        <TextWithIcon icon={PLACEHOLDER_ICON} empty>
          {l.translate('Add an image')}
        </TextWithIcon>
      </ContentContainer>
    )
  }

  if (card.image.type === CardImageType.EXTERNAL) {
    return <DynamicImagePreview url={card.image.url} containerProps={{ connectedToNext: true }} />
  }

  if (card.image.type === CardImageType.PREVIEW) {
    return (
      <PreviewComponent
        url={card.image.preview.url}
        ratio={ratio}
        size={card.image.preview.size}
        targetWidth={CARD_WIDTH}
        connectedToNext
      />
    )
  }

  return null
}
